import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: "Rajesh Kumar",
      location: "Noida",
      rating: 5,
      text: "Pandit ji's guidance helped me overcome career obstacles. His remedies were simple yet powerful. Within months, I got the promotion I had been waiting for years.",
      avatar: "RK",
    },
    {
      name: "Priya Sharma",
      location: "Delhi",
      rating: 5,
      text: "The Vastu consultation transformed our home's energy. We feel more peaceful and prosperous. My family relationships have improved significantly.",
      avatar: "PS",
    },
    {
      name: "Anita Gupta",
      location: "Greater Noida",
      rating: 5,
      text: "His spiritual healing sessions brought harmony to our family. Truly blessed to have found him. The Kundali matching for my daughter was spot on.",
      avatar: "AG",
    },
    {
      name: "Vikram Singh",
      location: "Ghaziabad",
      rating: 5,
      text: "I was skeptical at first, but Pandit ji's numerology reading changed my perspective. His name correction suggestion brought positive changes in my business.",
      avatar: "VS",
    },
    {
      name: "Meera Patel",
      location: "Sector 62, Noida",
      rating: 5,
      text: "The face reading session was incredibly accurate. Pandit ji identified my strengths and challenges perfectly. His guidance has been invaluable for my personal growth.",
      avatar: "MP",
    },
  ];

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setActiveIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section id="testimonials" className="py-20 lg:py-32 bg-background relative">
      {/* Decorative Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-amber/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-primary font-medium mb-2">Testimonials</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Client <span className="text-gradient-gold">Testimonials</span>
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Hear from our satisfied clients about their transformative experiences
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-4xl mx-auto">
          {/* Main Card */}
          <Card className="bg-card border-border overflow-hidden">
            <CardContent className="p-8 lg:p-12">
              <div className="flex flex-col items-center text-center">
                {/* Quote Icon */}
                <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-6">
                  <Quote className="w-8 h-8 text-primary" />
                </div>

                {/* Testimonial Text */}
                <p className="text-lg lg:text-xl text-foreground leading-relaxed mb-8 max-w-2xl">
                  &ldquo;{testimonials[activeIndex].text}&rdquo;
                </p>

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 text-primary fill-primary"
                    />
                  ))}
                </div>

                {/* Author */}
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-amber flex items-center justify-center">
                    <span className="font-display text-lg font-semibold text-primary-foreground">
                      {testimonials[activeIndex].avatar}
                    </span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-display text-lg font-semibold text-foreground">
                      {testimonials[activeIndex].name}
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {testimonials[activeIndex].location}
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <Button
              variant="outline"
              size="icon"
              onClick={prevSlide}
              className="rounded-full border-border hover:bg-primary hover:text-primary-foreground hover:border-primary"
            >
              <ChevronLeft className="w-5 h-5" />
            </Button>

            {/* Dots */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    index === activeIndex
                      ? "bg-primary w-8"
                      : "bg-border hover:bg-muted-foreground"
                  }`}
                />
              ))}
            </div>

            <Button
              variant="outline"
              size="icon"
              onClick={nextSlide}
              className="rounded-full border-border hover:bg-primary hover:text-primary-foreground hover:border-primary"
            >
              <ChevronRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
